import DataModuleBaseUtils from './data-module-base-utils';

export default class ColleagueUsageUtils extends DataModuleBaseUtils {
  whole = () => 10;

  value = ({rawValue}) => rawValue;

  decoratedValue = ({value}) => (value || '').toLocaleString();

  comparisonValue = () => '3';

  headerCopy = () => 'Colleagues using Raise Me';

  headerLinkCopy = () => 'Invite More Colleagues';

  bodyHeader = () => 'Aim for teacher-counselor balance';

  bodyContent = () =>
    'Raise Me is most effective when used by teachers for motivation and counselors for college discovery.';

  comparisonLabel = () => 'Raise Me Avg:';

  surveyLocalStorageKey = () => 'Survey::DataModules:ColleagueUsage';
}
